import { createLocalStorageStateHook } from "use-local-storage-state";

const useAlert = createLocalStorageStateHook<number | undefined>(
  "alertDuration"
);

export default useAlert;
